export const BASE_FONT_SIZE = 14;
export const BASE_LINE_HEIGHT = 1.43;